document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-sf-countdown]').forEach((node) => {
    let hours = parseInt(node.getAttribute('data-hours') || '23', 10);
    let minutes = parseInt(node.getAttribute('data-minutes') || '47', 10);
    let seconds = parseInt(node.getAttribute('data-seconds') || '32', 10);

    const hourEl = node.querySelector('[data-sf-hours]');
    const minuteEl = node.querySelector('[data-sf-minutes]');
    const secondEl = node.querySelector('[data-sf-seconds]');

    const render = () => {
      if (hourEl) hourEl.textContent = String(hours).padStart(2, '0');
      if (minuteEl) minuteEl.textContent = String(minutes).padStart(2, '0');
      if (secondEl) secondEl.textContent = String(seconds).padStart(2, '0');
    };

    render();

    window.setInterval(() => {
      if (seconds > 0) {
        seconds -= 1;
      } else if (minutes > 0) {
        minutes -= 1;
        seconds = 59;
      } else if (hours > 0) {
        hours -= 1;
        minutes = 59;
        seconds = 59;
      }
      render();
    }, 1000);
  });

  document.querySelectorAll('[data-sf-scroll-target]').forEach((button) => {
    button.addEventListener('click', () => {
      const targetId = button.getAttribute('data-sf-scroll-target');
      if (!targetId) return;
      const target = document.getElementById(targetId);
      if (target) target.scrollIntoView({ behavior: 'smooth' });
    });
  });

  document.querySelectorAll('[data-sf-bundle-card]').forEach((card) => {
    card.addEventListener('click', () => {
      const group = card.closest('[data-sf-bundle-group]');
      if (!group) return;
      group.querySelectorAll('[data-sf-bundle-card]').forEach((el) => el.classList.remove('is-selected'));
      card.classList.add('is-selected');
    });
  });
});
